import type { CommentFieldValue } from "@/shared/components/comment-field/use-comment-field";
import { isRichTextValue } from "./rich-text";

/**
 * Type guard to check if a value is a CommentFieldValue
 */
export function isCommentFieldValue(
  value: unknown,
): value is CommentFieldValue {
  if (!value || typeof value !== "object") {
    return false;
  }

  const obj = value as Record<string, unknown>;

  // Check that it's an object with at least content or attachment
  if (!("content" in obj) && !("attachment" in obj)) {
    return false;
  }

  // If content exists, it must be a RichTextDto
  if ("content" in obj) {
    if (obj.content === undefined || obj.content === null) {
      return false;
    }
    if (!isRichTextValue(obj.content)) {
      return false;
    }
  }

  // If attachment exists, it must be a File or null
  if (
    "attachment" in obj &&
    obj.attachment !== undefined &&
    obj.attachment !== null
  ) {
    if (!(obj.attachment instanceof File)) {
      return false;
    }
  }

  return true;
}
